import React from "react";
import { View, Text, TouchableOpacity, StyleSheet, ScrollView } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useTheme } from "../../../context/ThemeContext";

const ActivityItem = ({ item }) => {
	const theme = useTheme();
	const styles = useStyles();

	return (
		<View style={styles.activityItem}>
			<View style={styles.activityIcon}>
				<Ionicons name={item.icon || "bookmark-outline"} size={20} color={theme.colors.systemGreen} />
			</View>
			<View style={styles.activityContent}>
				<Text style={styles.activityText}>
					<Text style={styles.activityUser}>{item.user}</Text> {item.action} <Text style={styles.activityTarget}>{item.target}</Text>
				</Text>
				<Text style={styles.activityTime}>{item.time}</Text>
			</View>
			{item.hasInteraction && (
				<TouchableOpacity style={styles.interactionButton}>
					<Ionicons name="heart-outline" size={20} color={theme.colors.textSecondary} />
				</TouchableOpacity>
			)}
		</View>
	);
};

export const ActivityFeed = ({ content, label = "Recent Activity" }) => {
	const theme = useTheme();
	const styles = useStyles();

	return (
		<View style={styles.container}>
			<View style={styles.header}>
				<Text style={styles.label}>{label}</Text>
				<TouchableOpacity style={styles.moreButton}>
					<Text style={styles.moreButtonText}>View All</Text>
					<Ionicons name="arrow-forward" size={16} color={theme.colors.primary} />
				</TouchableOpacity>
			</View>
			<ScrollView style={styles.feed} showsVerticalScrollIndicator={false}>
				{content.items.map((activity) => (
					<ActivityItem key={activity.id} item={activity} />
				))}
			</ScrollView>
		</View>
	);
};

const useStyles = () => {
	const theme = useTheme();

	return StyleSheet.create({
		container: {
			backgroundColor: theme.colors.systemBackground.primary,
			marginBottom: theme.spacing.sm,
			height: 280,
			borderRadius: theme.borderRadius.lg,
			...theme.shadows.sm,
		},
		header: {
			flexDirection: "row",
			justifyContent: "space-between",
			alignItems: "center",
			paddingHorizontal: theme.spacing.md,
			paddingTop: theme.spacing.sm,
			paddingBottom: theme.spacing.xs,
		},
		label: {
			...theme.typography.subhead,
			color: theme.colors.textSecondary,
			fontWeight: "500",
		},
		moreButton: {
			flexDirection: "row",
			alignItems: "center",
			gap: theme.spacing.xs,
		},
		moreButtonText: {
			...theme.typography.subhead,
			color: theme.colors.primary,
		},
		feed: {
			flex: 1,
		},
		activityItem: {
			flexDirection: "row",
			alignItems: "center",
			paddingVertical: theme.spacing.sm,
			paddingHorizontal: theme.spacing.md,
			borderBottomWidth: StyleSheet.hairlineWidth,
			borderBottomColor: theme.colors.separator,
		},
		activityIcon: {
			width: 32,
			height: 32,
			backgroundColor: theme.colors.systemBackground.secondary,
			borderRadius: theme.borderRadius.md,
			justifyContent: "center",
			alignItems: "center",
			marginRight: theme.spacing.sm,
		},
		activityContent: {
			flex: 1,
		},
		activityText: {
			...theme.typography.subhead,
			color: theme.colors.textSecondary,
			marginBottom: theme.spacing.xxs,
		},
		activityUser: {
			color: theme.colors.text,
			fontWeight: "500",
		},
		activityTarget: {
			color: theme.colors.primary,
		},
		activityTime: {
			...theme.typography.caption2,
			color: theme.colors.textTertiary,
		},
		interactionButton: {
			padding: theme.spacing.xs,
		},
	});
};
